<template>
 <AppLoader
    v-if="
      ($route.name == 'Login' ||
        $route.name == 'Register' ||
        $route.name == 'Forgot Password' ||
        $route.name == 'Reset Password' ||
        $route.name == 'Get OTP') &&
      store.loading
    "
  />
  <router-view />
</template>

<script>
import AppLoader from "./components/shared/AppLoader.vue";
import { useMainStore } from "@/store";
import $ from 'jquery'

export default {
setup() {
    const store = useMainStore();
    return { store };
  },
  components: { AppLoader },
  created(){
    this.store.getFlavourData({},false).then(response =>{
        if(Object.keys(response).length && response.userCountry && Object.keys(response.userCountry).length && response.userCountry.isoCode){
            for(var key in this.static_vars.cretioCountryJson){
                if(key == response.userCountry.isoCode){
                    var s = document.createElement("script");
                    s.type = "text/javascript";
                    s.async = true;
                    s.src = `//dynamic.criteo.com/js/ld/ld.js?a=${this.static_vars.cretioCountryJson[key]}`;
                    $("head").append(s);
                    window.criteo_q = window.criteo_q || [];
                }
            }
        }
    })
    setTimeout(() =>{
        this.store.affilateLanded({},false)
    },3000);
  }
};
</script>
<style>
@import "../node_modules/vue-toastification/dist/index.css";
  .Vue-Toastification__toast-body {
    font-size: 13px !important;
    line-height: 18px !important;
  }
  .Vue-Toastification__toast {
    padding: 20px 13px;
    max-width: 460px;
  }
</style>